<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>subscriptions</mat-icon></div>
      <h4>{{ formMode }} Subscription</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Group</mat-label>
        <mat-select formControlName="group_name" required>
          @for (group of groupList; track group.group_name) {
            <mat-option [value]="group.group_name">{{ group.group_name }}</mat-option>
          }
        </mat-select>
        @if (entryForm.controls['group_name'].hasError('required')) {
          <mat-error>Group is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Channel</mat-label>
        <mat-select formControlName="channel_name" required>
          @for (channel of channelList; track channel.channel_name) {
            <mat-option [value]="channel.channel_name">{{ channel.channel_name }}</mat-option>
          }
        </mat-select>
        @if (entryForm.controls['channel_name'].hasError('required')) {
          <mat-error>Channel is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
        @if (entryForm.controls['Description'].hasError('required')) {
          <mat-error>Description is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editSubscription) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate_Update()">
        <mat-icon>add</mat-icon> Add Subscription
      </button>
    }
    @if (editSubscription) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
